module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "400px",
      "margin": "auto"
    },
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "90px",
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('el-row', [(_vm.invoiceList && _vm.invoiceList.length > 0) ? _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "invoiceId"
    }
  }, [_vm._v("发票模板：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceId),
      expression: "invoiceId"
    }],
    staticClass: "invoiceId",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.invoiceId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeInvoice]
    }
  }, [_c('option', {
    attrs: {
      "label": "请选择"
    },
    domProps: {
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.invoiceList), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "label": item.invoiceHeader
      },
      domProps: {
        "value": item.id
      }
    })
  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "invoiceType"
    }
  }, [_vm._v("发票类型：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invoiceType),
      expression: "form.invoiceType"
    }],
    staticClass: "invoiceType",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "invoiceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "label": "普通发票-电子",
      "value": "0"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "invoiceHeaderType"
    }
  }, [_vm._v("抬头类型：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-radio', {
    attrs: {
      "label": "个人或者事业单位"
    },
    model: {
      value: (_vm.invoiceHeaderType),
      callback: function($$v) {
        _vm.invoiceHeaderType = $$v
      },
      expression: "invoiceHeaderType"
    }
  }, [_vm._v("个人或者事业单位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "企业"
    },
    model: {
      value: (_vm.invoiceHeaderType),
      callback: function($$v) {
        _vm.invoiceHeaderType = $$v
      },
      expression: "invoiceHeaderType"
    }
  }, [_vm._v("企业")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "invoiceHeader"
    }
  }, [_vm._v("发票抬头：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invoiceHeader),
      expression: "form.invoiceHeader"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "填写需要开具发票的姓名"
    },
    domProps: {
      "value": (_vm.form.invoiceHeader)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invoiceHeader", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.invoiceHeaderType == '企业') ? _c('div', {
    staticClass: "el-form-item is-required"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "dutyParagraph"
    }
  }, [_vm._v("税号：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.dutyParagraph),
      expression: "form.dutyParagraph"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "请填写纳税人识别号"
    },
    domProps: {
      "value": (_vm.form.dutyParagraph)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "dutyParagraph", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.invoiceHeaderType == '企业') ? _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "bankName"
    }
  }, [_vm._v("开户银行：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bankName),
      expression: "form.bankName"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "选填"
    },
    domProps: {
      "value": (_vm.form.bankName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bankName", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.invoiceHeaderType == '企业') ? _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "bankCardNo"
    }
  }, [_vm._v("银行账号：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bankCardNo),
      expression: "form.bankCardNo"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "选填"
    },
    domProps: {
      "value": (_vm.form.bankCardNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bankCardNo", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.invoiceHeaderType == '企业') ? _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "companyAddress"
    }
  }, [_vm._v("企业地址：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyAddress),
      expression: "form.companyAddress"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "选填"
    },
    domProps: {
      "value": (_vm.form.companyAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyAddress", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.invoiceHeaderType == '企业') ? _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "companyMobile"
    }
  }, [_vm._v("企业电话：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.companyMobile),
      expression: "form.companyMobile"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "选填"
    },
    domProps: {
      "value": (_vm.form.companyMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "companyMobile", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "for": "invoiceHeader"
    }
  }, [_vm._v("发票内容：")]), _vm._v(" "), _c('div', {
    staticClass: "el-form-item__content",
    staticStyle: {
      "margin-left": "100px"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.form.isInvoiceDetails),
      callback: function($$v) {
        _vm.$set(_vm.form, "isInvoiceDetails", $$v)
      },
      expression: "form.isInvoiceDetails"
    }
  }, [_vm._v("明细")])], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "saveBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateData
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17166804","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/components/ApplyInvoice.vue
// module id = 743
// module chunks = 2